import React from 'react';
import { motion } from 'framer-motion';
import { useScrollProgress } from '../../hooks/useScrollProgress';
export function ScrollProgress() {
  const progress = useScrollProgress();
  return <motion.div className="fixed top-0 left-0 right-0 h-1 bg-gold origin-left z-50" style={{
    scaleX: progress / 100
  }} initial={{
    scaleX: 0
  }} transition={{
    duration: 0.1
  }} data-id="element-243" />;
}